import { Component, OnInit } from '@angular/core';

import { ModalService } from '@app/shared/services/modal.service';

import { Router } from '@angular/router';
import { SisrhService } from '@app/services/sisrh.service';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadArquivoComponent } from '@app/components/upload-arquivo/upload-arquivo.component';
import { Cidade, ExcluirRequisitoInscricao, Indicador } from '@app/models/sisrh.model';
import { AppUtil } from '@app/utils/app.util';

import perguntas from '@assets/json/questionario-governanca-corporativa-compliance.json';
import {FormBuilder, FormGroup, FormArray, Validators, FormControl} from '@angular/forms';
import { CnpjValidator } from '@app/validators/cnpj.validator';
import { subscribeOn, timeout } from 'rxjs/operators';
import { ElementRef } from '@angular/core'; // at the top of component.ts
import { AutenticacaoService } from '@app/services/autenticacao.service';


@Component({
  templateUrl: './inscricao.page.html'
})
export class InscricaoPage implements OnInit {

  mascaraCnpj = AppUtil.mascararCnpj();

  idInscricao: string;
  detalheVagaPorInscricao: Observable<any>;
  inscricaoRequisitoPorInscricao: Observable<any>;
  arquivosEnviados = [];

  listaPerguntas = perguntas;

  enviando = false;
  enviandoPr2 = false;
  enviandoPr3 = false;
  enviandoPr4 = false;
  enviandoPr6 = false;
  enviandoPr7 = false;

  formularioInteresse: FormGroup;

  fgPerguntasRespostas: FormGroup;
  fgPerguntaResposta1: FormGroup;
  fgPerguntaResposta2: FormGroup;
  fgPerguntaResposta3: FormGroup;
  fgPerguntaResposta4: FormGroup;
  fgPerguntaResposta6: FormGroup;
  fgPerguntaResposta7: FormGroup;
  fgPerguntaResposta8: FormGroup;

  cidades: Cidade[];
  ufs: any[];

  aPerguntaResposta2 = [];
  aPerguntaResposta3 = [];

  readonly idTipoIndicadorParentesco = '46BCAECB-2BA5-44A8-A5B1-3CD548F9D3CD';
  parentesco: Indicador[];

  cpfCandidato;

  constructor(
    private modalService: ModalService,
    private router: Router,
    private sisrhService: SisrhService,
    private ngbModal: NgbModal,
    private fb: FormBuilder,
    private myElement: ElementRef,
    private autenticacaoService: AutenticacaoService
  ) {

    this.cpfCandidato = this.autenticacaoService.getValorUsuarioAtualCandidato.cpf;
    if (localStorage.getItem('idInscricao')) {
      this.idInscricao = localStorage.getItem('idInscricao');
    } else {
      this.router.navigate(['/vagas/lista']);
    }

  }

  ngOnInit() {
    this.carregarControleFormulario();

    this.fgPerguntasRespostas = this.fb.group({
      respostas: this.fb.array([
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[0].idPergunta,
          resposta: ['']
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[1].idPergunta,
          resposta: ['', [Validators.required]]
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[2].idPergunta,
          resposta: ['', [Validators.required]]
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[3].idPergunta,
          resposta: ['', [Validators.required]]
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[4].idPergunta,
          resposta: ['', [Validators.required]]
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[5].idPergunta,
          resposta: ['', [Validators.required]]
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[6].idPergunta,
          resposta: ['', [Validators.required]]
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[7].idPergunta,
          resposta: ['']
        }),
        this.fb.group({
          idQuestionarioPergunta: this.listaPerguntas[8].idPergunta,
          resposta: ['']
        })
      ])
    });

    this.resetPr1();
    this.resetPr2();
    this.resetPr3();
    this.resetPr4();
    this.resetPr6();
    this.resetPr7();
    this.resetPr8();

    this.fgPerguntaResposta2.disable();
    this.fgPerguntaResposta3.disable();
    this.fgPerguntaResposta4.disable();
    this.fgPerguntaResposta6.disable();
    this.fgPerguntaResposta7.disable();


    this.carregarDetalheVagaPorInscricao();
    this.carregarInscricaoRequisitoPorInscricao();
    this.carregarParentesco();
    this.carregarUfs();
  }

  carregarControleFormulario() {
    this.formularioInteresse = this.fb.group({
      escolhaCadastroReserva: new FormControl('')
    });
  }

  abrirEnvioArquivo(idVagaRequisito: string) {

    const inputModal = this.ngbModal.open(
      UploadArquivoComponent, {
      ariaLabelledBy: 'ssModalUploadArquivo'
    });
    inputModal.componentInstance.idInscricao = this.idInscricao;
    inputModal.componentInstance.idVagaRequisito = idVagaRequisito;

    inputModal.componentInstance.arquivoEvento.subscribe(
      () => this.carregarInscricaoRequisitoPorInscricao(),
      () => this.modalService.alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.')
    );

  }

  visualizarArquivo(inscricaoRequisito: any) {

    this.sisrhService
      .baixarArquivos(inscricaoRequisito.idInscricaoRequisito)
      .subscribe(
        x => {
          const id = inscricaoRequisito.idInscricaoRequisito.slice(0, 8);
          const nomeArquivo = `${id}_${inscricaoRequisito.titulo.slice(0, 15).replace(/[^0-9a-zA-Z]+/g, '').toLowerCase()}`;
          AppUtil.abrirArquivo(x, nomeArquivo);
        },
        () => this.modalService.alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.')
      );

  }

  excluirArquivo(idInscricaoRequisito: string) {

    const excluirRequisitoInscricao: ExcluirRequisitoInscricao = {
      idInscricaoRequisito
    };
    this.sisrhService
      .excluirComprovante(excluirRequisitoInscricao)
      .subscribe(
        () => this.carregarInscricaoRequisitoPorInscricao(),
        () => this.modalService.alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.')
      );

  }

  get cpr1() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[0] as FormGroup;

  }

  get cpr2() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[1] as FormGroup;

  }

  get cpr3() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[2] as FormGroup;

  }

  get cpr4() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[3] as FormGroup;

  }

  get cpr5() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[4] as FormGroup;

  }

  get cpr6() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[5] as FormGroup;

  }

  get cpr7() {

    return (this.fgPerguntasRespostas.controls.respostas as FormArray).controls[6] as FormGroup;

  }

  get capr1() {
    return this.fgPerguntaResposta1.controls;
  }

  get capr2() {

    return this.fgPerguntaResposta2.controls;

  }

  get capr3() {

    return this.fgPerguntaResposta3.controls;

  }

  get capr4() {

    return this.fgPerguntaResposta4.controls;

  }

  get capr6() {

    return this.fgPerguntaResposta6.controls;

  }

  get capr7() {
    return this.fgPerguntaResposta7.controls;
  }

  get capr8() {
    return this.fgPerguntaResposta8.controls;
  }

  resetPr1() {
    this.fgPerguntaResposta1 = this.fb.group({
      respostaPontosFortes: ['', Validators.required],
      respostaPontosFracos: ['', Validators.required]
    });
  }

  resetPr2() {

    this.fgPerguntaResposta2 = this.fb.group({
      respostaRazaoSocial: ['', Validators.required],
      respostaCnpj: ['', [
        CnpjValidator.cnpjInvalido,
        Validators.required
      ]],
      respostaPorcentagemParticipacao: ['', Validators.required],
      respostaFuncao: ['', Validators.required]
    });

  }

  resetPr3() {

    this.fgPerguntaResposta3 = this.fb.group({
      respostaNomeEmpregado: ['', Validators.required],
      respostaCargoEmpregado: ['', Validators.required],
      respostaUnidadeParente: ['', Validators.required],
      respostaTipoParentesco: ['', Validators.required]
    });

  }

  resetPr4() {

    this.fgPerguntaResposta4 = this.fb.group({
      respostaNaoSim: '',
      respostaDescreva: ['', Validators.required]
    });

  }

  resetPr6() {

    this.fgPerguntaResposta6 = this.fb.group({
      respostaNaoSim: '',
      respostaOnde: ['', Validators.required],
      respostaCargo: ['', Validators.required],
      respostaPeriodoInicial: ['', Validators.required],
      respostaPeriodoFinal: ['', Validators.required],
      respostaCargoAtual: false
    });

  }

  resetPr7() {
    this.fgPerguntaResposta7 = this.fb.group({
      respostaNomeCandidato: ['', Validators.required],
      respostaTipoParentesco: ['', Validators.required]
    });
  }

  resetPr8() {
    this.fgPerguntaResposta8 = this.fb.group({
      respostaUf: ['',  Validators.required],
      respostaCidade: ['', Validators.required]
    });

    this.capr8.respostaUf.valueChanges.subscribe(uf => {
      if (uf) {
        this.sisrhService.BuscarCidadesPorUf(uf).subscribe(data => {
          this.cidades = data;
        });
      }
    });
  }


  incluirPr2() {

    this.enviandoPr2 = true;

    if (this.fgPerguntaResposta2.invalid) {
      return;
    }

    this.aPerguntaResposta2.push(this.fgPerguntaResposta2.value);
    this.resetPr2();
    this.enviandoPr2 = false;
    AppUtil.focalizarCampo('idRazaoSocial');

  }

  incluirPr3() {
    this.enviandoPr3 = true;

    if (this.fgPerguntaResposta3.invalid) {
      return;
    }
    this.aPerguntaResposta3.push(this.fgPerguntaResposta3.value);
    this.resetPr3();
    this.enviandoPr3 = false;
    AppUtil.focalizarCampo('idNomeEmpregado');
  }

  removerPr2(index: number) {
    this.aPerguntaResposta2.splice(index, 1);
  }

  removerPr3(index: number) {
    this.aPerguntaResposta3.splice(index, 1);
  }

  desativarFormPr2() {

    this.enviandoPr2 = false;
    this.aPerguntaResposta2 = [];

    if (this.cpr2.controls.resposta.value === 'nao') {
      this.fgPerguntaResposta2.controls.respostaRazaoSocial.setValue('');
      this.fgPerguntaResposta2.controls.respostaCnpj.setValue('');
      this.fgPerguntaResposta2.controls.respostaPorcentagemParticipacao.setValue('');
      this.fgPerguntaResposta2.controls.respostaFuncao.setValue('');
      this.fgPerguntaResposta2.disable();
    } else {
      this.fgPerguntaResposta2.enable();
    }

  }

  desativarFormPr3() {

    this.enviandoPr3 = false;
    this.aPerguntaResposta3 = [];

    if (this.cpr3.controls.resposta.value === 'nao') {
      this.fgPerguntaResposta3.reset('');
      this.fgPerguntaResposta3.disable();
    } else {
      this.fgPerguntaResposta3.enable();
    }

  }

  desativarFormPr4() {

    this.enviandoPr4 = false;

    if (this.cpr4.controls.resposta.value === 'nao') {
      this.fgPerguntaResposta4.controls.respostaDescreva.setValue('');
      this.fgPerguntaResposta4.disable();
    } else {
      this.fgPerguntaResposta4.enable();
    }

  }

  desativarFormPr6() {

    this.enviandoPr6 = false;

    if (this.cpr6.controls.resposta.value === 'nao') {
      this.fgPerguntaResposta6.controls.respostaOnde.setValue('');
      this.fgPerguntaResposta6.controls.respostaPeriodoInicial.setValue('');
      this.fgPerguntaResposta6.controls.respostaPeriodoFinal.setValue('');
      this.fgPerguntaResposta6.controls.respostaCargoAtual.setValue(false);
      this.fgPerguntaResposta6.controls.respostaCargo.setValue('');
      this.fgPerguntaResposta6.disable();
    } else {
      this.fgPerguntaResposta6.enable();
    }

  }

  desativarFormPr7() {
    this.enviandoPr7 = false;

    if (this.cpr7.controls.resposta.value === 'nao') {
      this.fgPerguntaResposta7.reset('');
      this.fgPerguntaResposta7.disable();
    } else {
      this.fgPerguntaResposta7.enable();
    }
  }

  finalizar() {

    if (this.arquivosEnviados.filter(x => x.arquivos === 0).length !== 0) {
      this.modalService
        .alert('e', 'Atenção', 'Você deve anexar os comprovantes obrigatórios.');
      return;
    }

    this.enviando = true;
    this.enviandoPr3 = true;
    this.enviandoPr4 = true;
    this.enviandoPr6 = true;
    this.enviandoPr7 = true;

    if (this.fgPerguntaResposta1.invalid) {
      return;
    }

    if (this.cpr2.controls.resposta.value === 'sim' && this.aPerguntaResposta2.length === 0) {
      this.incluirPr2();
        let el = this.myElement.nativeElement.querySelector('#questionarioCompliance');
        el.scrollIntoView();
        return;
    }

    if (this.cpr3.controls.resposta.value === 'sim' && this.aPerguntaResposta3.length === 0) {
      this.modalService
        .alert('e', 'Erro', 'O formulário do Terceiro Questionário é obrigatório.');
      return;
    }

    if (this.cpr4.controls.resposta.value === 'sim' && this.fgPerguntaResposta4.invalid) {
      return;
    }

    if (this.cpr6.controls.resposta.value === 'sim' && this.fgPerguntaResposta6.invalid) {
      return;
    }

    if (this.cpr7.controls.resposta.value === 'sim' && this.fgPerguntaResposta7.invalid) {
      return;
    }

    if (this.fgPerguntaResposta8.invalid) {
      return;
    }

    if (this.fgPerguntasRespostas.invalid) {
      return;
    }

    const respostas = [];
    const numeroDePerguntas = this.fgPerguntasRespostas.value.respostas.length;
    const resultadoEscolha = this.formularioInteresse.get('escolhaCadastroReserva').value;

    for (let i = 0; i < numeroDePerguntas; i++) {

      const resposta = Object.assign(
        {}, ((this.fgPerguntasRespostas.controls.respostas as FormArray).controls[i] as FormGroup).value
      );

      switch (i) {
        case 0:
          resposta.resposta = this.fgPerguntaResposta1.get('respostaPontosFortes').value;
          break;
        case 1:
          resposta.resposta = JSON.stringify({
            respostaNaoSim: resposta.resposta,
            respostaAdicionada: this.aPerguntaResposta2
          });
          break;
        case 2:
          resposta.resposta = JSON.stringify({
            respostaNaoSim: resposta.resposta,
            respostaAdicionada: this.aPerguntaResposta3
          });
          break;
        case 3:
          const resposta4 = Object.assign({}, this.fgPerguntaResposta4.value);
          resposta4.respostaNaoSim = resposta.resposta;
          resposta.resposta = JSON.stringify(resposta4);
          break;
        case 5:
          const resposta6 = Object.assign({}, this.fgPerguntaResposta6.value);
          resposta6.respostaNaoSim = resposta.resposta;
          resposta6.respostaPeriodoFinal = resposta6.respostaCargoAtual ? '' : resposta6.respostaPeriodoFinal;
          delete resposta6.respostaCargoAtual;
          resposta.resposta = JSON.stringify(resposta6);
          break;
        case 6:
          const resposta7 = {
            respostaNaoSim: resposta.resposta,
            ...this.fgPerguntaResposta7.value,
          };
          resposta.resposta = JSON.stringify(resposta7);
          break;
        case 7:
          resposta.resposta = JSON.stringify(this.fgPerguntaResposta8.value);
          break;
        case 8:
          resposta.resposta = this.fgPerguntaResposta1.get('respostaPontosFracos').value;
          break;
      }
      respostas.push(resposta);
    }
    const inscricaoComRespostas = {
      idInscricao: this.idInscricao,
      respostas,
      escolhaVagaReserva: resultadoEscolha
    };

    this.desativarInscricao();

    this.sisrhService.preencherRespostas(inscricaoComRespostas)
      .subscribe(x => {
        if (x.success) {
          this.sisrhService.finalizarInscricao({ idInscricao: this.idInscricao })
            .subscribe(
              y => {
                if (y.success) {
                  this.modalService
                    .alert('s', 'Sucesso', y.message)
                    .subscribe(() => this.router.navigate(['/vagas/lista']));
                } else {
                  this.modalService
                  .alert('e', 'Atenção', y.data[0].message)
                  .subscribe(() => this.router.navigate(['/vagas/lista']));
                }
                console.log(y);
              },
              () => this.modalService.alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.').subscribe(this.ativarInscricao));
        } else {
          this.modalService.alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.').subscribe(this.ativarInscricao);
        }
      }, () => this.modalService.alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.').subscribe(this.ativarInscricao));

  }

  ativarInscricao() {
    this.fgPerguntasRespostas.enable();
    if (this.cpr2.controls.resposta.value && this.cpr2.controls.resposta.value === 'sim') {
      this.fgPerguntaResposta2.enable();
    }
    if (this.cpr3.controls.resposta.value && this.cpr3.controls.resposta.value === 'sim') {
      this.fgPerguntaResposta3.enable();
    }
    if (this.cpr4.controls.resposta.value && this.cpr4.controls.resposta.value === 'sim') {
      this.fgPerguntaResposta4.enable();
    }
    if (this.cpr6.controls.resposta.value && this.cpr6.controls.resposta.value === 'sim') {
      this.fgPerguntaResposta6.enable();
    }
    this.enviando = false;
    this.enviandoPr2 = false;
    this.enviandoPr3 = false;
    this.enviandoPr4 = false;
    this.enviandoPr6 = false;
  }

  desativarInscricao() {
    this.fgPerguntasRespostas.disable();
    this.fgPerguntaResposta2.disable();
    this.fgPerguntaResposta3.disable();
    this.fgPerguntaResposta4.disable();
    this.fgPerguntaResposta6.disable();
  }

  desativaDataSaida(evento) {

    if (evento.target.checked) {
      this.fgPerguntaResposta6.controls.respostaPeriodoFinal.setValue('');
      this.capr6.respostaPeriodoFinal.disable();
      this.resetPr2();
    } else {
      this.capr6.respostaPeriodoFinal.enable();
    }

  }

  carregarDetalheVagaPorInscricao() {

    this.detalheVagaPorInscricao = this.sisrhService.detalheVagaPorInscricao(this.idInscricao);

  }

  carregarInscricaoRequisitoPorInscricao() {

    this.inscricaoRequisitoPorInscricao = this.sisrhService.inscricaoRequisitoPorInscricao(this.idInscricao);
    this.inscricaoRequisitoPorInscricao.subscribe(x => this.arquivosEnviados = x);

  }

  carregarParentesco() {
    this.sisrhService.BuscarIndicadoresPorIdTipo(this.idTipoIndicadorParentesco).subscribe(data => {
      this.parentesco = data;
    });
  }

  carregarUfs() {
    this.ufs = [
      { label: 'AC', value: 'AC' },
      { label: 'AL', value: 'AL' },
      { label: 'AP', value: 'AP' },
      { label: 'AM', value: 'AM' },
      { label: 'BA', value: 'BA' },
      { label: 'CE', value: 'CE' },
      { label: 'DF', value: 'DF' },
      { label: 'ES', value: 'ES' },
      { label: 'GO', value: 'GO' },
      { label: 'MA', value: 'MA' },
      { label: 'MT', value: 'MT' },
      { label: 'MS', value: 'MS' },
      { label: 'MG', value: 'MG' },
      { label: 'PA', value: 'PA' },
      { label: 'PB', value: 'PB' },
      { label: 'PR', value: 'PR' },
      { label: 'PE', value: 'PE' },
      { label: 'PI', value: 'PI' },
      { label: 'RJ', value: 'RJ' },
      { label: 'RN', value: 'RN' },
      { label: 'RS', value: 'RS' },
      { label: 'RO', value: 'RO' },
      { label: 'RR', value: 'RR' },
      { label: 'SC', value: 'SC' },
      { label: 'SP', value: 'SP' },
      { label: 'SE', value: 'SE' },
      { label: 'TO', value: 'TO' },
    ];
  }
}
